/**
 * Zone.js configuration to prevent patching of events that cause passive listener warnings
 * This file should be imported before zone.js in polyfills.ts
 */

// Disable patching of specific events that cause passive event listener warnings
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'touchstart',
  'touchmove',
  'touchend',
  'wheel',
  'mousewheel'
];